var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/antd/~/lodash/_Symbol.js
// module id = 149
// module chunks = 0